/* ============================================================================
 * BUSCADOR INTELIGENTE MOTIONFLUID (predictivo + tolerante a errores)
 * ----------------------------------------------------------------------------
 * Mismo motor del buscador de Cohynsa, AUTO-CONTENIDO y con la piel de Motion:
 *   - Inyecta su propio CSS (paleta azul→cian, redondeado, sombra premium).
 *   - Crea su propio panel de resultados anclado bajo la barra de búsqueda del
 *     header (la que se expande con la lupa: input[type=search][name=q]).
 *   - Índice cliente de TODOS los productos (/products.json), cacheado en
 *     sessionStorage (TTL 15 min) y precargado al primer foco.
 *   - Match difuso: sin acentos, prefijo, subcadena, SKU, marca/tipo y
 *     DISTANCIA DE EDICIÓN (Levenshtein) para tolerar errores de dedo
 *     ("mangera" → manguera, "conexon" → conexión).
 *   - Panel con foto + título + marca·tipo + precio; teclado (↑↓ Enter Esc);
 *     fila degradada "Ver todos los resultados" → búsqueda nativa.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__smartSearch) return;
  window.__smartSearch = true;

  /* ======================= CONFIGURACIÓN ======================= */
  var CONFIG = {
    // caja(s) de búsqueda del tema (evita inputs ocultos de facetas)
    inputSelector: 'input[type="search"], input[name="q"]:not([type="hidden"])',
    accent: '#0077C8',                 // azul de acción (Minimal)
    accent2: '#0077C8',                // (Minimal: sin degradados)
    ink: '#0F1720',                     // texto (Minimal)
    maxResults: 7,
    debounceMs: 110,
    cacheKey: 'ss_index_v3',           // v3: tipo de producto en inglés en /en. Súbelo para forzar recarga
    cacheTtlMs: 15 * 60 * 1000,
  };
  /* ============================================================= */

  /* ---------- normalización ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')   // quita acentos
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---------- Levenshtein acotado (con corte para velocidad) ---------- */
  function lev(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    if (la === 0) return lb; if (lb === 0) return la;
    var prev = new Array(lb + 1), cur = new Array(lb + 1), i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur[0] = i; var best = cur[0];
      for (j = 1; j <= lb; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      var tmp = prev; prev = cur; cur = tmp;
    }
    return prev[lb];
  }

  /* ---------- índice de productos ---------- */
  var INDEX = null, loading = null;
  /* raíz del idioma activo ('/' o '/en/'): el índice y los enlaces siguen el idioma de la página */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CKEY = function () { return CONFIG.cacheKey + '_' + (ROOT.replace(/\//g, '') || 'es'); };

  function fromCache() {
    try {
      var o = JSON.parse(sessionStorage.getItem(CKEY()) || 'null');
      if (!o || (Date.now() - o.t) > CONFIG.cacheTtlMs || !Array.isArray(o.d)) return null;
      return o.d;
    } catch (e) { return null; }
  }
  function toCache(d) { try { sessionStorage.setItem(CKEY(), JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function thumb(src) { return src ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=96' : ''; }

  /* El tipo de producto no se traduce en Shopify (las pestañas del catálogo lo comparan en
     español), así que en /en el buscador usa esta tabla para mostrarlo y buscarlo en inglés.
     El tipo en español se sigue indexando también: quien escriba "manguera" en /en lo encuentra. */
  var TYPE_EN = {
    'Adaptadores Hidráulicos': 'Hydraulic Adapters', 'Conexiones acoples para mangueras hidráulicas': 'Hydraulic Hose Fittings',
    'Conexiones Waltech': 'Waltech Fittings', 'Tratamiento de Aire': 'Air Preparation', 'Conexiones de Leva y Ranura': 'Cam & Groove Couplings',
    'Conexión de instrumentación': 'Instrumentation Fittings', 'Adaptador de instrumentación': 'Instrumentation Adapters',
    'Componente de instrumentación': 'Instrumentation Components', 'Niple de instrumentación': 'Instrumentation Nipples',
    'Tapón de instrumentación': 'Instrumentation Plugs', 'Válvula de instrumentación': 'Instrumentation Valves',
    'Conexiones y Accesorios Neumáticos': 'Pneumatic Fittings & Accessories', 'Manómetros, Vacóumetros y Accesorios': 'Pressure Gauges, Vacuum Gauges & Accessories',
    'Manómetros, Vacuometros y Accesorios': 'Pressure Gauges, Vacuum Gauges & Accessories', 'Elementos Filtrantes': 'Filter Elements',
    'Mangueras Hidráulicas': 'Hydraulic Hoses', 'Mangueras Industriales': 'Industrial Hoses', 'Manifold': 'Manifolds',
    'Valvulas Industriales': 'Industrial Valves', 'Electroválvulas': 'Solenoid Valves', 'Cilindros Neumáticos': 'Pneumatic Cylinders',
    'Acoplamientos flexibles': 'Flexible Couplings', 'Tubing Neumático': 'Pneumatic Tubing', 'Campanas de acoplamiento': 'Bell Housings',
    'Válvula Neumática Pilotada': 'Pilot-Operated Pneumatic Valves', 'Sub-base': 'Subplates', 'Placa Ciega': 'Blanking Plates',
    'Bushing de reducción': 'Reducing Bushings', 'Sellos': 'Seals', 'Refacciones de acoplamiento': 'Coupling Spare Parts',
    'Válvula direccional Atos': 'Atos Directional Valves', 'Válvula proporcional de presión Atos': 'Atos Proportional Pressure Valves',
    'Válvula proporcional direccional de alto desempeño Atos': 'Atos High-Performance Proportional Directional Valves',
    'Válvula de seguridad Atos': 'Atos Safety Valves', 'Válvula modular Atos': 'Atos Modular Valves',
    'Servoválvula proporcional direccional Atos': 'Atos Proportional Directional Servovalves',
    'Válvula proporcional de presión de alto desempeño Atos': 'Atos High-Performance Proportional Pressure Valves',
    'Servobomba Atos': 'Atos Servopumps', 'Accesorio proporcional Atos': 'Atos Proportional Accessories', 'Driver electrónico Atos': 'Atos Electronic Drivers',
    'Cilindro hidráulico Atos': 'Atos Hydraulic Cylinders', 'Válvula proporcional direccional Atos': 'Atos Proportional Directional Valves',
    'Válvula proporcional de seguridad Atos': 'Atos Proportional Safety Valves', 'Control de eje Atos': 'Atos Axis Controls',
    'Válvula de presión Atos': 'Atos Pressure Valves', 'Válvula de cartucho ISO Atos': 'Atos ISO Cartridge Valves',
    'Válvula proporcional de caudal Atos': 'Atos Proportional Flow Valves', 'Control p/Q Atos': 'Atos p/Q Controls',
    'Accesorio para válvulas on-off Atos': 'Atos On-Off Valve Accessories', 'Bomba de desplazamiento fijo Atos': 'Atos Fixed Displacement Pumps',
    'Válvula antirretorno Atos': 'Atos Check Valves', 'Bomba múltiple Atos': 'Atos Multiple Pumps', 'Filtro en línea Atos': 'Atos In-Line Filters',
    'Unidad de potencia hidráulica Atos': 'Atos Hydraulic Power Units', 'Válvula reguladora de caudal Atos': 'Atos Flow Control Valves',
    'Componente complementario Atos': 'Atos Complementary Components', 'Bomba de desplazamiento variable Atos': 'Atos Variable Displacement Pumps',
    'Bloque hidráulico Atos': 'Atos Hydraulic Blocks', 'Accesorio de control de eje Atos': 'Atos Axis Control Accessories',
    'Subplaca Atos': 'Atos Subplates', 'Servoactuador Atos': 'Atos Servoactuators', 'Accesorio para cilindros Atos': 'Atos Cylinder Accessories',
    'Filtro de retorno Atos': 'Atos Return Filters', 'Filtro de succión Atos': 'Atos Suction Filters'
  };

  function buildRecord(p) {
    var vs = p.variants || [], skus = [], minP = null, avail = false, i;
    for (i = 0; i < vs.length; i++) {
      if (vs[i].sku) skus.push(vs[i].sku);
      var pr = parseFloat(vs[i].price);
      if (!isNaN(pr) && (minP === null || pr < minP)) minP = pr;
      if (vs[i].available) avail = true;
    }
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    var img = (p.images && p.images[0]) ? p.images[0].src : (p.image ? p.image.src : '');
    var nt = norm(p.title);
    var tyEs = p.product_type || '', ty = (isEn() && TYPE_EN[tyEs]) || tyEs;
    return {
      t: p.title, h: p.handle, v: p.vendor || '', ty: ty,
      img: thumb(img), p: minP, av: avail, vc: vs.length,
      cot: tags.some(function (t) { return /cotiza/i.test(t); }),
      nt: nt, w: nt.split(' ').filter(Boolean), sk: skus.map(norm),
      bt: norm([p.vendor, ty, ty !== tyEs ? tyEs : ''].join(' ')),   // marca + tipo (coincidencia SÓLIDA; en /en, inglés + español)
      tg: norm(tags.join(' ')),                          // tags (coincidencia DÉBIL, no ancla)
    };
  }

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    var cached = fromCache();
    if (cached) { INDEX = cached; return Promise.resolve(INDEX); }
    loading = (function () {
      var all = [];
      function page(n) {
        return fetch(ROOT + 'products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var ps = (j && j.products) || [], i;
            for (i = 0; i < ps.length; i++) all.push(buildRecord(ps[i]));
            if (ps.length === 250 && n < 8) return page(n + 1);
          });
      }
      return page(1).then(function () { INDEX = all; toCache(all); loading = null; return INDEX; })
        .catch(function () { loading = null; return (INDEX = INDEX || []); });
    })();
    return loading;
  }

  /* ---------- puntuación difusa ---------- */
  function maxDist(len) { return len <= 4 ? 1 : (len <= 7 ? 2 : 3); }

  // Devuelve { s: puntaje, solid: true si la coincidencia es de TÍTULO/palabra/SKU/marca-tipo
  // (ancla real) y false si es sólo substring de título, tag o fuzzy flojo. El "solid" evita
  // que basura entre por un tag: ej. "5 mall" no debe traer conexiones que sólo tienen el tag
  // "conexion-mallas" — su "mall" es tag (débil), mientras la manguera lo tiene como palabra.
  function tokenScore(tok, rec) {
    var i, w;
    if (rec.nt.indexOf(tok) === 0) return { s: 34, solid: true };   // el título empieza con el token
    var best = 0;
    for (i = 0; i < rec.w.length; i++) {                            // palabra del título (1ª pesa más)
      w = rec.w[i];
      if (w === tok) best = Math.max(best, i === 0 ? 32 : 26);
      else if (w.indexOf(tok) === 0) best = Math.max(best, i === 0 ? 28 : 21);
    }
    if (best) return { s: best, solid: true };
    for (i = 0; i < rec.sk.length; i++) if (rec.sk[i].indexOf(tok) === 0) return { s: 26, solid: true };  // SKU
    var bt = rec.bt || '', tg = rec.tg || '';
    if (bt.indexOf(tok) >= 0) return { s: 14, solid: true };        // marca / tipo (búsqueda legítima)
    if (rec.nt.indexOf(tok) >= 0) return { s: 15, solid: false };   // substring a media palabra: débil
    if (tg.indexOf(tok) >= 0) return { s: 7, solid: false };        // tag: débil, no ancla
    if (tok.length >= 3) {                                          // typos
      var md = maxDist(tok.length), b = md + 1, bi = -1;
      for (i = 0; i < rec.w.length; i++) {
        w = rec.w[i]; if (Math.abs(w.length - tok.length) > md) continue;
        var d = lev(tok, w, md); if (d < b) { b = d; bi = i; } if (b === 1) break;
      }
      if (b <= md) { var base = Math.max(4, 13 - b * 3); return { s: bi === 0 ? base + 9 : base, solid: true }; }  // typo en palabra del título = sólido
      var hw = (bt + ' ' + tg).split(' '), b2 = md + 1;
      for (i = 0; i < hw.length; i++) {
        w = hw[i]; if (!w || Math.abs(w.length - tok.length) > md) continue;
        var d2 = lev(tok, w, md); if (d2 < b2) b2 = d2; if (b2 === 1) break;
      }
      if (b2 <= md) return { s: Math.max(3, 10 - b2 * 3), solid: false };
    }
    return { s: 0, solid: false };
  }

  function search(q, limit) {
    var qn = norm(q); if (!qn || !INDEX) return [];
    var toks = qn.split(' ').filter(Boolean), multi = toks.length > 1, res = [], i, k;
    for (i = 0; i < INDEX.length; i++) {
      var rec = INDEX[i], sc = 0, all = true, solid = 0;
      for (k = 0; k < toks.length; k++) {
        var m = tokenScore(toks[k], rec);
        if (m.s <= 0) { all = false; break; }
        if (m.solid) solid++;
        sc += m.s;
      }
      if (!all) continue;
      if (multi && solid === 0) continue;   // 2+ palabras: exige al menos una coincidencia sólida (no sólo tags)
      if (rec.nt.indexOf(qn) === 0) sc += 45; else if (rec.nt.indexOf(qn) >= 0) sc += 22;
      if (rec.av) sc += 3;
      res.push({ r: rec, s: sc });
    }
    res.sort(function (a, b) { return b.s !== a.s ? b.s - a.s : a.r.t.length - b.r.t.length; });
    return res.slice(0, limit || CONFIG.maxResults).map(function (x) { return x.r; });
  }

  /* ---------- render ---------- */
  function money(n) { return '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function isEn() { return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0; }
  function metaOf(r) { return [r.v, r.ty].filter(Boolean).join(' · '); }

  function render(panel, q, list, loadingState) {
    if (loadingState) { panel.innerHTML = '<div class="ss-state">' + (isEn() ? 'Searching…' : 'Buscando…') + '</div>'; panel.style.display = 'block'; return; }
    var html = '';
    if (!list.length) {
      html = '<div class="ss-state">' + (isEn() ? 'No results for ' : 'Sin resultados para ') + '<b>“' + esc(q) + '”</b>.<br>' +
        '<span>' + (isEn() ? 'Try the brand, the type, or check the spelling.' : 'Prueba con la marca, el tipo o revisa la ortografía.') + '</span></div>';
    } else {
      html = '<ul class="ss-list">';
      for (var i = 0; i < list.length; i++) {
        var r = list[i], meta = metaOf(r);
        var price = r.cot ? '<span class="ss-cot">' + (isEn() ? 'On request' : 'Bajo cotización') + '</span>'
                  : (r.p != null && r.p > 0 ? '<span class="ss-price">' + (r.vc > 1 ? (isEn() ? 'From ' : 'Desde ') : '') + money(r.p) + '</span>' : '');
        html += '<li class="ss-item"><a href="' + ROOT + 'products/' + esc(r.h) + '">' +
          (r.img ? '<img class="ss-img" src="' + esc(r.img) + '" alt="" loading="lazy">' : '<span class="ss-img ss-noimg"></span>') +
          '<span class="ss-tx"><span class="ss-t">' + esc(r.t) + '</span>' +
          (meta ? '<span class="ss-meta">' + esc(meta) + '</span>' : '') + '</span>' + price + '</a></li>';
      }
      html += '</ul>';
    }
    html += '<a class="ss-all" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last">' +
      (isEn() ? 'See all results for ' : 'Ver todos los resultados de ') + '“' + esc(q) + '” <span>→</span></a>';
    panel.innerHTML = html;
    panel.style.display = 'block';
  }

  /* ---------- CSS auto-inyectado (piel Motionfluid) ---------- */
  function injectCSS() {
    if (document.getElementById('ss-css')) return;
    var a = CONFIG.accent, a2 = CONFIG.accent2, ink = CONFIG.ink;
    var css = [
      '.ss-panel{position:fixed;z-index:100000;background:#fff;border-radius:14px;',
      'box-shadow:0 18px 40px -16px rgba(15,23,32,.22);',
      'border:1px solid #E4E7EC;max-height:min(72vh,480px);overflow-y:auto;display:none;',
      "font-family:var(--mm-font,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif);-webkit-overflow-scrolling:touch}",
      '.ss-panel::-webkit-scrollbar{width:8px}.ss-panel::-webkit-scrollbar-thumb{background:#D5DAE1;border-radius:999px}',
      '.ss-list{list-style:none;margin:0;padding:7px}',
      '.ss-item a{display:flex;align-items:center;gap:13px;padding:10px 11px;border-radius:10px;text-decoration:none;color:#0F1720;transition:background .15s ease}',
      '.ss-item a:hover,.ss-item.ss-sel a{background:#F5F6F8}',
      '.ss-img{width:50px;height:50px;flex:0 0 auto;border-radius:10px;object-fit:contain;background:#fff;border:1px solid #E4E7EC;padding:3px;mix-blend-mode:multiply}',
      '.ss-noimg{background:#F5F6F8;mix-blend-mode:normal}',
      '.ss-tx{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px}',
      '.ss-t{font-size:13.5px;font-weight:600;line-height:1.32;color:#0F1720;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.ss-meta{font-size:12px;font-weight:400;color:#5B6675;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.ss-price{flex:0 0 auto;font-size:13.5px;font-weight:600;color:#0F1720;white-space:nowrap;font-variant-numeric:tabular-nums}',
      '.ss-cot{flex:0 0 auto;font-size:12px;font-weight:600;color:' + a + ';white-space:nowrap}',
      '.ss-all{display:flex;align-items:center;justify-content:center;gap:6px;padding:13px;margin-top:2px;',
      'background:#fff;border-top:1px solid #E4E7EC;color:' + a + ';font-size:14px;font-weight:600;',
      'text-decoration:none;border-radius:0 0 14px 14px;transition:background .15s ease}',
      '.ss-all:hover{background:#F5F6F8}.ss-all span{font-size:15px;transition:transform .2s ease}.ss-all:hover span{transform:translateX(3px)}',
      '.ss-state{padding:26px 20px;text-align:center;color:' + ink + ';font-size:13.5px;line-height:1.55}',
      '.ss-state b{color:#0F1720}.ss-state span{display:block;margin-top:5px;font-size:12px;color:#5B6675}',
      /* ---- página de resultados /search (takeover): cuadrícula estilo Motion ---- */
      '.ssr-wrap{max-width:1200px;margin:0 auto;padding:6px 16px 64px}',
      '.ssr-head{font-family:inherit;font-size:22px;font-weight:700;color:' + ink + ';margin:6px 4px 20px;letter-spacing:-.01em}',
      '.ssr-head b{color:#0F1720}',
      '.ssr-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:18px}',
      '.ssr-card{display:flex;flex-direction:column;background:#fff;border:1px solid #E4E7EC;border-radius:16px;padding:14px;text-decoration:none;',
      'transition:border-color .3s ease}',
      '.ssr-card:hover{border-color:#D5DAE1}',
      '.ssr-card img,.ssr-noimg{width:100%;aspect-ratio:1;object-fit:contain;background:#fff;border-radius:12px;margin-bottom:12px;mix-blend-mode:multiply}',
      '.ssr-noimg{background:#F5F6F8;mix-blend-mode:normal}',
      '.ssr-ct{font-size:14px;font-weight:600;line-height:1.34;color:#0F1720;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:4px}',
      '.ssr-meta{font-size:12px;font-weight:400;color:#5B6675;margin-bottom:8px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}',
      '.ssr-pr{margin-top:auto;font-size:15px;font-weight:600;color:#0F1720;font-variant-numeric:tabular-nums}',
      '.ssr-cot{margin-top:auto;align-self:flex-start;font-size:13px;font-weight:600;color:' + a + '}',
      '.ssr-empty{text-align:center;padding:60px 20px;color:' + ink + ';font-size:1rem;line-height:1.6}',
      /* cuando tomamos la página de resultados, ocultamos TODO lo nativo (con !important
         para ganarle a los estilos/JS del tema que reabren el título con la cuenta vieja) */
      'html.ss-took-over body .search-results-title,html.ss-took-over body #ProductGridContainer,html.ss-took-over body #main-search-filters,html.ss-took-over body .template-search [role="status"]{display:none !important}',
      'html.ss-took-over [data-ss-native],html.ss-pending [data-ss-native]{display:none !important}',
      '@media (max-width:600px){.ssr-grid{grid-template-columns:repeat(2,1fr);gap:12px}.ssr-card{padding:11px;border-radius:15px}.ssr-ct{font-size:12.5px}.ssr-head{font-size:1rem}}',
      /* iOS: input de búsqueda ≥16px en móvil para que no haga zoom al enfocar */
      '@media (max-width:1099px){input[type="search"],input[name="q"]{font-size:16px !important}}'
    ].join('');
    var st = document.createElement('style'); st.id = 'ss-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  /* ---------- conexión de cada input ---------- */
  function wire(input) {
    if (input.__ssWired) return; input.__ssWired = true;
    var panel = document.createElement('div'); panel.className = 'ss-panel';
    document.body.appendChild(panel);

    var timer = null, lastQ = '';
    function place() {
      var r = input.getBoundingClientRect();
      if (!r.width || r.bottom < 0) { panel.style.display = 'none'; return; }
      var w = Math.max(r.width, 300);                     // panel cómodo aunque la barra sea angosta
      var left = Math.min(r.left, window.innerWidth - w - 10);
      panel.style.top = (r.bottom + 8) + 'px';
      panel.style.left = Math.max(10, left) + 'px';
      panel.style.width = w + 'px';
    }
    function close() { panel.style.display = 'none'; panel.innerHTML = ''; }
    function moveSel(dir) {
      var items = [].slice.call(panel.querySelectorAll('.ss-item'));
      if (!items.length) return;
      var cur = panel.querySelector('.ss-item.ss-sel'), idx = items.indexOf(cur);
      if (cur) cur.classList.remove('ss-sel');
      idx = dir === 'down' ? (idx + 1) % items.length : (idx <= 0 ? items.length - 1 : idx - 1);
      items[idx].classList.add('ss-sel'); items[idx].scrollIntoView({ block: 'nearest' });
    }
    function run() {
      var q = input.value.trim(); lastQ = q;
      if (!q) { close(); return; }
      if (!INDEX) { render(panel, q, [], true); place();
        loadIndex().then(function () { if (input.value.trim() === lastQ) { render(panel, lastQ, search(lastQ), false); place(); } });
        return;
      }
      render(panel, q, search(q), false); place();
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, CONFIG.debounceMs); });
    input.addEventListener('focus', function () { loadIndex(); if (input.value.trim()) run(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveSel('down'); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveSel('up'); }
      else if (e.key === 'Enter') { var sel = panel.querySelector('.ss-item.ss-sel a'); if (sel) { e.preventDefault(); location.href = sel.getAttribute('href'); } }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    document.addEventListener('click', function (e) { if (e.target !== input && !panel.contains(e.target)) close(); });
    window.addEventListener('scroll', function () { if (panel.style.display === 'block') place(); }, true);
    window.addEventListener('resize', function () { if (panel.style.display === 'block') place(); });
  }

  /* ---------- takeover de la página de resultados /search ----------
   * La búsqueda NATIVA de Shopify devuelve resultados irrelevantes para este
   * catálogo (ej. "5 mall" → adaptadores/conexiones). Aquí, en la página de
   * resultados, reemplazamos la rejilla nativa por la de NUESTRO motor para
   * CUALQUIER consulta. Si el índice no cargó, se deja el nativo (no rompe). */
  function bigImg(u) { return u ? u.replace(/width=\d+/, 'width=440') : u; }

  /* ---------- takeover del diseño Minimal (sections/mm-search.liquid) ----------
   * El encabezado (H1 con la consulta y el campo) lo pone Liquid. Aquí dibujamos, con los
   * resultados de NUESTRO motor: cuenta, filtros Marca/Tipo y orden (sobre esos mismos
   * resultados), tarjetas y "Mostrar más". Lo nativo ([data-ss-native]) se oculta; si el
   * índice no carga, se quita "ss-pending" y lo nativo queda visible como respaldo. */
  function takeoverMM(host, q) {
    var root = document.documentElement;
    loadIndex().then(function () {
      if (!INDEX || !INDEX.length) { root.classList.remove('ss-pending'); return; }
      try {
        var en = isEn(), all = search(q, 400);   /* todas las coincidencias relevantes; se muestran de 24 en 24 */
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var st = { v: {}, ty: {}, sort: 'rel', shown: 24, open: '' };
        var quote = host.getAttribute('data-quote') || 'https://wa.me/524423431901';
        var catalog = host.getAttribute('data-catalog') || '/pages/catalogo-de-productos';
        function L(es, e) { return en ? e : es; }
        function on(map) { return Object.keys(map).filter(function (k) { return map[k]; }); }
        function pick(list, skip) {
          var av = skip === 'v' ? [] : on(st.v), at = skip === 'ty' ? [] : on(st.ty);
          return list.filter(function (r) { return (!av.length || av.indexOf(r.v) >= 0) && (!at.length || at.indexOf(r.ty) >= 0); });
        }
        function facet(key) {
          var m = {}, list = pick(all, key);
          list.forEach(function (r) { var k = r[key]; if (k) m[k] = (m[k] || 0) + 1; });
          on(st[key]).forEach(function (k) { if (!m[k]) m[k] = 0; });
          return Object.keys(m).sort(function (a, b) { return m[b] - m[a] || a.localeCompare(b); }).map(function (k) { return [k, m[k]]; });
        }
        function price(r) { return (r.cot || r.p == null || r.p <= 0) ? Infinity : r.p; }
        function results() {
          var list = pick(all);
          if (st.sort === 'pa' || st.sort === 'pd') {
            list = list.slice().sort(function (a, b) {
              var pa = price(a), pb = price(b);
              if (pa === pb) return 0;
              if (pa === Infinity) return 1;
              if (pb === Infinity) return -1;
              return st.sort === 'pa' ? pa - pb : pb - pa;
            });
          }
          return list;
        }
        var chev = '<span class="mm-sr__chev" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></span>';
        function dd(key, label) {
          var opts = facet(key);
          if (opts.length < 2 && !on(st[key]).length) return '';
          var n = on(st[key]).length, h = '<details class="mm-sr__f" data-ssf="' + key + '"' + (st.open === key ? ' open' : '') + '>' +
            '<summary class="mm-sr__fbtn' + (n ? ' is-on' : '') + '">' + label + (n ? '<span class="mm-sr__fn">' + n + '</span>' : '') + chev + '</summary><div class="mm-sr__menu">';
          opts.forEach(function (o) {
            var act = !!st[key][o[0]];
            h += '<button type="button" class="mm-sr__opt' + (act ? ' is-on' : '') + (!o[1] && !act ? ' is-off' : '') + '" role="menuitemcheckbox" aria-checked="' + act + '" data-ssk="' + key + '" data-ssv="' + esc(o[0]) + '">' +
              '<span class="mm-sr__box" aria-hidden="true"></span><span class="mm-sr__olabel">' + esc(o[0]) + '</span><span class="mm-sr__ocount">' + o[1] + '</span></button>';
          });
          return h + '</div></details>';
        }
        function card(r) {
          var meta = metaOf(r);
          var pr = r.cot ? '<span class="mm-src__cot">' + L('Precio bajo cotización', 'Price on request') + '</span>'
            : (r.p != null && r.p > 0 ? '<span class="mm-src__p">' + (r.vc > 1 ? L('Desde ', 'From ') : '') + money(r.p) + '</span>' : '');
          return '<a class="mm-src" href="' + base + 'products/' + esc(r.h) + '">' +
            '<span class="mm-src__media">' + (r.img ? '<img src="' + esc(bigImg(r.img)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="mm-src__t">' + esc(r.t) + '</span>' + (meta ? '<span class="mm-src__m">' + esc(meta) + '</span>' : '') + pr + '</a>';
        }
        function draw() {
          var list = results(), n = list.length, h = '';
          if (!all.length) {
            h = '<div class="mm-sr__none"><p class="mm-sr__none-t">' + L('Sin resultados para', 'No results for') + ' “' + esc(q) + '”.</p>' +
              '<p class="mm-sr__none-s">' + L('Prueba con el número de parte, la marca o el tipo de producto, o revisa la ortografía.', 'Try the part number, the brand or the product type, or check the spelling.') + '</p>' +
              '<div class="mm-sr__none-cta"><a class="mm-btn" href="' + esc(quote) + '" target="_blank" rel="noopener">' + L('Pedir cotización', 'Ask us for a quote') + '</a>' +
              '<a class="mm-btn mm-btn--ghost" href="' + esc(catalog) + '">' + L('Ver el catálogo', 'Browse the catalog') + '</a></div></div>';
            host.innerHTML = h; return;
          }
          h += '<div class="mm-sr__bar"><p class="mm-sr__count" role="status"><b>' + n + '</b> ' + (n === 1 ? L('resultado', 'result') : L('resultados', 'results')) + '</p><div class="mm-sr__tools">' +
            dd('v', L('Marca', 'Brand')) + dd('ty', L('Tipo de producto', 'Product type')) +
            '<label class="mm-sr__sort"><span class="mm-vh">' + L('Ordenar por', 'Sort by') + '</span><select data-sssort aria-label="' + L('Ordenar por', 'Sort by') + '">' +
            '<option value="rel"' + (st.sort === 'rel' ? ' selected' : '') + '>' + L('Más relevantes', 'Most relevant') + '</option>' +
            '<option value="pa"' + (st.sort === 'pa' ? ' selected' : '') + '>' + L('Precio: menor a mayor', 'Price: low to high') + '</option>' +
            '<option value="pd"' + (st.sort === 'pd' ? ' selected' : '') + '>' + L('Precio: mayor a menor', 'Price: high to low') + '</option></select>' + chev + '</label></div></div>';
          var chips = on(st.v).map(function (k) { return ['v', k]; }).concat(on(st.ty).map(function (k) { return ['ty', k]; }));
          if (chips.length) {
            h += '<div class="mm-sr__active">' + chips.map(function (c) {
              return '<button type="button" class="mm-sr__chip" data-ssk="' + c[0] + '" data-ssv="' + esc(c[1]) + '">' + esc(c[1]) + ' <span aria-hidden="true">×</span><span class="mm-vh">' + L('Quitar filtro', 'Remove filter') + '</span></button>';
            }).join('') + '<button type="button" class="mm-sr__clear" data-ssclear>' + L('Quitar todos', 'Clear all') + '</button></div>';
          }
          h += '<div class="mm-src-grid">' + list.slice(0, st.shown).map(card).join('') + '</div>';
          if (n > st.shown) h += '<div class="mm-sr__more"><button type="button" class="mm-btn mm-btn--ghost" data-ssmore>' + L('Mostrar más', 'Show more') + ' (' + (n - st.shown) + ')</button></div>';
          host.innerHTML = h;
        }
        host.addEventListener('click', function (e) {
          var t = e.target.closest('[data-ssk],[data-ssclear],[data-ssmore]');
          if (!t) return;
          if (t.hasAttribute('data-ssmore')) { st.shown += 24; draw(); return; }
          if (t.hasAttribute('data-ssclear')) { st.v = {}; st.ty = {}; st.open = ''; st.shown = 24; draw(); return; }
          var k = t.getAttribute('data-ssk'), v = t.getAttribute('data-ssv');
          st[k][v] = !st[k][v];
          st.open = t.classList.contains('mm-sr__opt') ? k : '';
          st.shown = 24; draw();
        });
        host.addEventListener('change', function (e) {
          if (!e.target.matches('[data-sssort]')) return;
          st.sort = e.target.value; st.open = ''; draw();
        });
        host.addEventListener('toggle', function (e) {
          var d = e.target;
          if (!d.matches || !d.matches('details[data-ssf]')) return;
          if (d.open) { st.open = d.getAttribute('data-ssf'); host.querySelectorAll('details[data-ssf]').forEach(function (o) { if (o !== d) o.open = false; }); }
          else if (st.open === d.getAttribute('data-ssf')) st.open = '';
        }, true);
        document.addEventListener('click', function (e) {
          /* composedPath conserva la ruta aunque el botón ya se haya redibujado */
          var path = e.composedPath ? e.composedPath() : [e.target];
          if (path.indexOf(host) >= 0) return;
          st.open = '';
          host.querySelectorAll('details[data-ssf][open]').forEach(function (d) { d.open = false; });
        });
        draw();
        root.classList.add('ss-took-over');
        root.classList.remove('ss-pending');
      } catch (e) { root.classList.remove('ss-pending'); }
    });
  }

  function takeoverSearchPage() {
    if (!/(^|\/)search\/?$/.test(location.pathname)) return;
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) { q = ''; }
    q = q.trim();
    if (!q) return;
    var mmHost = document.querySelector('[data-ss-results]');
    if (mmHost) { takeoverMM(mmHost, q); return; }
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    loadIndex().then(function () {
      if (!INDEX || !INDEX.length) return;          // sin índice: deja el nativo intacto
      try {
        var list = search(q, 60);
        var host = document.createElement('div'); host.className = 'ssr-wrap';
        var n = list.length;
        var head = isEn()
          ? (n + ' result' + (n === 1 ? '' : 's') + ' for <b>“' + esc(q) + '”</b>')
          : (n + ' resultado' + (n === 1 ? '' : 's') + ' para <b>“' + esc(q) + '”</b>');
        var html = '<div class="ssr-head">' + head + '</div>';
        if (!n) {
          html += '<div class="ssr-empty">' + (isEn()
            ? 'No products matched. Try the brand, the type, or check the spelling.'
            : 'No encontramos productos. Prueba con la marca, el tipo o revisa la ortografía.') + '</div>';
        } else {
          html += '<div class="ssr-grid">';
          for (var i = 0; i < n; i++) {
            var r = list[i], meta = metaOf(r);
            var price = r.cot ? '<span class="ssr-cot">' + (isEn() ? 'Price on request' : 'Precio bajo cotización') + '</span>'
              : (r.p != null && r.p > 0 ? '<span class="ssr-pr">' + (r.vc > 1 ? (isEn() ? 'From ' : 'Desde ') : '') + money(r.p) + '</span>' : '');
            html += '<a class="ssr-card" href="' + ROOT + 'products/' + esc(r.h) + '">' +
              (r.img ? '<img src="' + esc(bigImg(r.img)) + '" alt="" loading="lazy">' : '<span class="ssr-noimg"></span>') +
              '<span class="ssr-ct">' + esc(r.t) + '</span>' +
              (meta ? '<span class="ssr-meta">' + esc(meta) + '</span>' : '') + price + '</a>';
          }
          html += '</div>';
        }
        host.innerHTML = html;
        container.parentNode.insertBefore(host, container);
        // Oculta TODO lo nativo (rejilla + filtros + título con la cuenta vieja) vía clase
        // raíz + CSS !important: robusto contra el JS del tema que reabre el título.
        document.documentElement.classList.add('ss-took-over');
        // Refuerzo: inline !important le gana a cualquier hoja de estilos del tema
        // (ej. .search-results-title lleva `display:block !important` en el tema).
        document.querySelectorAll('.search-results-title, #ProductGridContainer, #main-search-filters, .template-search [role="status"]').forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      } catch (e) { /* si algo falla, el nativo queda visible */ }
    });
  }

  function init() {
    injectCSS();
    takeoverSearchPage();
    var inputs = document.querySelectorAll(CONFIG.inputSelector);
    for (var i = 0; i < inputs.length; i++) wire(inputs[i]);
    // el input del header puede aparecer/ocultarse (barra que se expande): re-escanea
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var ins = document.querySelectorAll(CONFIG.inputSelector);
        for (var i = 0; i < ins.length; i++) if (!ins[i].__ssWired) wire(ins[i]);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(function () { loadIndex(); }, { timeout: 4000 });
    else setTimeout(loadIndex, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
